import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {bodyPdf, pdfH1} from '../styles';

import {CultureCardPdf} from './CultureCardPdf';
import {CultureAnalysisPdfContext} from '../../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {orangeColors, empionOrangeGradient} from '../../../../layouts/theme/designSystem';

export const CultureHouseFirstPage = () => {
  const {t} = useTranslation('pdfDomain');

  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const cultureHouseFirstPage = data.cultureHouse.slice(0, 4);

  return (
    <Grid container sx={{background: empionOrangeGradient.dark}} height={'300px'} p={5}>
      <Typography variant='h1' sx={pdfH1} mb={3}>
        {t('cultureHouse.title')}
      </Typography>
      <Typography variant='h1' sx={pdfH1} mb={3} ml={1} color={orangeColors[70]}>
        1/2
      </Typography>

      <Typography sx={bodyPdf} mb={1}>
        {t('cultureHouse.textBlock')}
      </Typography>

      <Grid item container mt={4} gap={2} justifyContent={'center'}>
        <CultureCardPdf cultureHouse={cultureHouseFirstPage} />
      </Grid>
    </Grid>
  );
};
